// extracted by mini-css-extract-plugin
module.exports = {"LoginPage":"LoginPage_LoginPage__XdQiT","LoginPage_graphicContainer":"LoginPage_LoginPage_graphicContainer__zZHz8"};